import { formatNumberWithDots } from '@/shared/utils/format';

export const formatChartValue = (value: number) => {
  return formatNumberWithDots(value);
};

export const getCustomOverlayPosition = (
  mouseX: number,
  mouseY: number,
  tooltipWidth: number = 288,
  tooltipHeight: number = 200,
) => {
  const offset = 12;
  const padding = 10;

  let left = mouseX + offset;
  let top = mouseY + offset;

  if (left + tooltipWidth > window.innerWidth - padding) {
    left = mouseX - tooltipWidth - offset;
  }

  if (top + tooltipHeight > window.innerHeight - padding) {
    top = mouseY - tooltipHeight - offset;
  }

  left = Math.max(
    padding,
    Math.min(left, window.innerWidth - tooltipWidth - padding),
  );
  top = Math.max(
    padding,
    Math.min(top, window.innerHeight - tooltipHeight - padding),
  );

  return { x: left, y: top };
};
